<template>
  <div style="margin-top: -10px; padding-top: -20px">
    <v-container>
      <v-row>
        <v-col cols="12">
          <v-card>
            <v-card-title>
              Associação de Produtos com a Omie
              <v-spacer></v-spacer>
              <v-btn small color="primary" :loading="carregando" @click="carregarPendencias()" data-cy="atualizar-pendencias">
                Atualizar
              </v-btn>
            </v-card-title>
            <v-card-text>
              <p style="color:#666;">
                Produtos ainda não vinculados a um produto na Omie (pendentes de associação) ou que tiveram erro na
                última sincronização. Busque o produto correspondente na Omie e vincule manualmente.
              </p>

              <h3 style="margin-top:20px;">Pendentes de associação ({{ pendentes.length }})</h3>
              <v-data-table
                :headers="colunas"
                :items="pendentes"
                :loading="carregando"
                no-data-text="Nenhum produto pendente de associação"
                dense
              >
                <template v-slot:item.acoes="{ item }">
                  <v-btn small color="secondary" @click="abrirVinculacao(item)" data-cy="vincular-produto">
                    Vincular
                  </v-btn>
                </template>
              </v-data-table>

              <h3 style="margin-top:30px;">Com erro de sincronização ({{ comErro.length }})</h3>
              <v-data-table
                :headers="colunasErro"
                :items="comErro"
                :loading="carregando"
                no-data-text="Nenhum produto com erro de sincronização"
                dense
              >
                <template v-slot:item.acoes="{ item }">
                  <v-btn small color="secondary" @click="abrirVinculacao(item)" data-cy="revincular-produto">
                    Revincular
                  </v-btn>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog v-model="modalVinculacao" max-width="600px">
      <v-card v-if="produtoSelecionado">
        <v-card-title>Vincular "{{ produtoSelecionado.descproduto || produtoSelecionado.nomecd }}"</v-card-title>
        <v-card-text>
          <v-text-field
            outlined dense hide-details
            label="Buscar produto na Omie (descrição)"
            v-model="termoBusca"
            @keyup.enter="buscarNaOmie()"
            data-cy="termo-busca-omie"
            style="margin-bottom:10px;"
          ></v-text-field>
          <v-btn small color="primary" :loading="buscando" @click="buscarNaOmie()" data-cy="buscar-produtos-omie">Buscar</v-btn>

          <v-list style="margin-top:15px;max-height:300px;overflow-y:auto;">
            <v-list-item
              v-for="item in resultadosOmie"
              :key="item.codigo_produto"
              @click="produtoOmieEscolhido = item"
              :style="produtoOmieEscolhido && produtoOmieEscolhido.codigo_produto === item.codigo_produto ? 'background-color:#e3f2fd;' : ''"
            >
              <v-list-item-content>
                <v-list-item-title>{{ item.descricao }}</v-list-item-title>
                <v-list-item-subtitle>Código Omie: {{ item.codigo_produto }} — Código integração: {{ item.codigo_produto_integracao }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="modalVinculacao = false">Cancelar</v-btn>
          <v-btn color="primary" :disabled="!produtoOmieEscolhido" @click="confirmarVinculo()" data-cy="confirmar-vinculo">
            Vincular
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'AssociacaoOmie',
  data: () => ({
    carregando: false,
    buscando: false,
    pendentes: [],
    comErro: [],
    colunas: [
      { text: 'Produto', value: 'descproduto' },
      { text: 'Código PMS', value: 'codprodutopms' },
      { text: 'Ações', value: 'acoes', sortable: false },
    ],
    colunasErro: [
      { text: 'Produto', value: 'descproduto' },
      { text: 'Código Omie', value: 'cod_produto_omie' },
      { text: 'Última mensagem de erro', value: 'mensagem_erro_sincronizacao_omie' },
      { text: 'Ações', value: 'acoes', sortable: false },
    ],
    modalVinculacao: false,
    produtoSelecionado: null,
    termoBusca: '',
    resultadosOmie: [],
    produtoOmieEscolhido: null,
  }),
  mounted() {
    this.carregarPendencias()
  },
  methods: {
    carregarPendencias() {
      this.carregando = true
      this.$http.get('pdv/omie/pendencias')
        .then(resp => {
          this.pendentes = resp.data.pendentes || []
          this.comErro = resp.data.comErro || []
        })
        .catch(error => {
          console.log(error)
          this.$alertar('warning', 'Não foi possível carregar as pendências de associação Omie', '=(')
        })
        .finally(() => { this.carregando = false })
    },
    abrirVinculacao(item) {
      this.produtoSelecionado = item
      this.termoBusca = item.descproduto || item.nomecd || ''
      this.resultadosOmie = []
      this.produtoOmieEscolhido = null
      this.modalVinculacao = true
      this.buscarNaOmie()
    },
    buscarNaOmie() {
      this.buscando = true
      this.$http.get('pdv/omie/buscarProdutos', { params: { termo: this.termoBusca } })
        .then(resp => {
          this.resultadosOmie = resp.data || []
        })
        .catch(error => {
          console.log(error)
          this.$alertar('warning', 'Não foi possível buscar produtos na Omie', '=(')
        })
        .finally(() => { this.buscando = false })
    },
    confirmarVinculo() {
      if (!this.produtoOmieEscolhido) return

      this.$http.post('pdv/omie/associarProduto', {
        idproduto: this.produtoSelecionado.idproduto,
        cod_produto_omie: this.produtoOmieEscolhido.codigo_produto,
        idusuario: localStorage.getItem('idusuario'),
      })
        .then(() => {
          this.$alertar('success', 'Produto vinculado com sucesso!', '=)')
          this.modalVinculacao = false
          this.carregarPendencias()
        })
        .catch(error => {
          console.log(error)
          this.$alertar('warning', (error.response && error.response.data && error.response.data.message) || 'Não foi possível vincular o produto', '=(')
        })
    },
  },
}
</script>

<style scoped>
</style>
